.panel {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--sp-2);
}

/* `panelTitle` is DELETED (#2283 §3/§4, applied by #2349): this panel is a
   `PageSection` now, so its title is a real heading with the shared spacing
   contract rather than a private title system. `sectionHierarchy.test.ts`
   asserts the class can never be declared here again. */

.empty {
  margin: 0;
  color: var(--muted);
  font-size: var(--fs-sm);
}

.list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  width: 100%;
}

.entry,
.entryMuted {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--sp-2);
  font-size: var(--fs-sm);
  padding: var(--sp-1) 0;
  border-bottom: 1px solid var(--hair);
}

.entryMuted { color: var(--muted); }

.what { font-weight: 600; }

.from,
.at,
.reason {
  color: var(--muted);
}

/* Tabular so a column of timestamps lines up rather than jittering. */
.at { font-variant-numeric: tabular-nums; }

.who { color: var(--ink); }

.reason { font-style: italic; }
